/**
 * Wrapper for jquery plugin noty to be able to use mustache templates.
 */

var $  = require('js/sw-jquery/sw-jquery');
var _  = require('underscore');
var sw = require('js/lib/sw');

var defaultTemplate = require('rrTags/notifications/templates/tpl.noty-default-container.mustache');
var contentTemplate = require('rrTags/notifications/templates/tpl.noty-content-container.mustache');
var emptyTemplate   = require('rrTags/notifications/templates/tpl.noty-empty-container.mustache');
var blankTemplate   = require('rrTags/container/templates/tpl.empty.mustache');
var dialogTemplate  = require('rrTags/notifications/templates/tpl.noty-dialog-container.mustache');
var confirmTemplate = require('rrTags/notifications/templates/tpl.noty-confirm-container.mustache');

var DEFAULT_THEME   = 'sw-noty';
var MAX_HEIGHT_MODAL = '645px';

var ANIMATION_DEFAULT_OPEN = {height: 'toggle'};
var ANIMATION_DEFAULT_CLOSE = {height: 'toggle'};
var ANIMATION_DEFAULT_EASING = 'swing';
var ANIMATION_DEFAULT_SPEED = 500;

var swTemplateMap = {
  notyDefault: defaultTemplate,
  empty:       emptyTemplate,
  content:     contentTemplate,
  blank:       blankTemplate,
  confirm:     confirmTemplate
};

function triggerFragmentLoadedOnMessage($message) {
    sw.trigger('sw-fragment-loaded', $($message));
}

module.exports = {

    DEFAULT_THEME: DEFAULT_THEME,

    /**
     * Displays a Noty notification (http://ned.im/noty/)
     * @param  {Object} options Options hash for noty parameters.
     * @param  {string} options.type Type of noty (warning, success, or information).
     * @param  {string} options.layout Determines where the notification is displayed on page.
     * @param  {string} options.theme Determines wrapper CSS class name ('sw-noty').
     * @param  {string} options.template Html to be used (see tpl.notifications.mustache).
     * @param  {array}  options.closeWith Determines whether notification is closeable (['click', 'button', 'hover', 'backdrop']).
     * @param  {bool}   options.suppressFragmentLoaded Option to not run fragment loaded on the noty content
     *
     *
     * For more noty options:
     * @see http://ned.im/noty/#/about
     *
     *
     */
    displayNoty: function displayNoty(content, options) {

        options = options || {};

        if(options.swTemplate) {
            options.template = swTemplateMap[options.swTemplate];
            delete options.swTemplate;
        }

        var settings = _.defaults(options, {
            type:       'warning',
            layout:     'top',
            theme:      DEFAULT_THEME,
            closeWith:  ['button', 'click'],
            timeout:    10000,
            template:   defaultTemplate,
            animation: {
                open: 'animated fadeIn', // Animate.css class names
                close: 'animated fadeOut' // Animate.css class names
            },
            suppressFragmentLoaded: false,
            showCloseButton: true
        });

        var onShowFunc;
        var onShowOptions;

        if (settings.callback && settings.callback.onShow) {
          onShowOptions = settings.callback.onShow;
          onShowFunc = function() {
            if (!options.suppressFragmentLoaded) {
              triggerFragmentLoadedOnMessage(this.$bar);
            }

            onShowOptions.apply(this, arguments);
          };
        } else {
          settings.callback = settings.callback || {};
          onShowFunc = function() {
            if (!options.suppressFragmentLoaded) {
              triggerFragmentLoadedOnMessage(this.$bar);
            }

            var $iframes = this.$bar.swFindWithSelf('iframe');

            // TODO: make sure safari fixes this
            if (options.useNotySafariIframeFix) {
              $iframes.each(function() {
                this.src = this.src;
              });
            }
          };
        }

        settings.callback.onShow = onShowFunc;

        settings.template = settings.template.render({
          content: content,
          url: options.swUrl || '',
          eventName: options.swEventName || '',
          showCloseButton: settings.showCloseButton
        });

        return window.noty(settings);
    },

    error: function error(content, options) {
        return this.displayNoty(content, _.extend({
            type: 'warning'
        }, options || {}));
    },

    success: function success(content, options) {
        return this.displayNoty(content, _.extend({
            type: 'success'
        }, options || {}));
    },

    message: function message(content, options) {
        return this.displayNoty(content, _.extend({
            type: 'information'
        }, options || {}));
    },

    content: function contentFn(content, options) {
        var settings = _.defaults(options || {}, {
            type:       'content',
            template:   contentTemplate,
            modal:      true,
            timeout:    false,
            layout:     'center',
            closeWith:  ['button', 'backdrop']
        });

        return this.displayNoty(content, settings);
    },

    /**
     * Replacement for jQuery's UI Dialog.
     *
     * PLEASE use sparingly. This is to get jQuery UI out of our code base.
     *
     * @param  {string} selector  Selector for the div that contains the content.
     * @param  {string} title     Title to display in Noty header
     * @param  {bool} modal       Whether or not to show as a modal
     * @param  {string} width     Width of div (ie '600px')
     * @param  {string} className Class to be applied to content on noty
     * @param  {object} options   Hash of Noty options (http://ned.im/noty/)
     */
    dialog: function dialog(selector, title, modal, width, className, options) {
      var $content, contentHTML;

      options = options || {};

      var maxWidth = options.maxWidth || false;
      delete options.maxWidth;

      if (options.content) {
        // If content is provided as a string.
        contentHTML = options.content;

        delete options.content;
      } else {
        // Get content from selector.
        $content = $(selector).clone(true);

        // Most content is hidden on the page somewhere, so need to make sure the cloned content is visible.
        if ($content.is(':hidden'))  {
          $content.css({
            display: 'block'
          });
        }

        contentHTML = $content.prop('outerHTML');
      }

      var content = dialogTemplate.render({
        content: contentHTML,
        title: title ? title : '',
        width: width ? width : '',
        maxWidth: maxWidth,
        maxHeight: MAX_HEIGHT_MODAL
      });

      var settings = _.defaults(options, {
        type:     'content',
        modal:    modal,
        timeout:  false,
        template: blankTemplate,
        addClass: className,
        layout:   'swDialog',
        animation: {
          open: 'animated fadeIn', // Animate.css class names
          close: 'animated fadeOut' // Animate.css class names
        }
      });

      this.displayNoty(content, settings);
    },

    /**
     * Full screen display for noty.
     *
     * @param {string} content
     * @param {object} options
     * @returns {object} noty instance
     */
    full: function full(content, options) {
      var settings = _.defaults(options || {}, {
        type: 'full',
        template: defaultTemplate,
        modal: false,
        timeout: false,
        layout: 'swCenterFull',
        closeWith: ['button'],
        animation: {
          // Resetting to defaults here because animate.css is breaking scroll
          // TODO: Find out why and fix.
          open: ANIMATION_DEFAULT_OPEN,
          close: ANIMATION_DEFAULT_CLOSE,
          easing: ANIMATION_DEFAULT_EASING,
          speed: ANIMATION_DEFAULT_SPEED
        }
      });

      return this.displayNoty(content, settings);
    },

    /**
     *
     * Creates a confirmation modal for a link and a message.
     *
     * Useful for when you need a speed bump for a user action
     *
     * @param message
     * @param url
     * @param eventName
     */
    confirm: function confirm(message, url, eventName) {
      this.full(message, {
        layout: 'center',
        swUrl: url,
        swEventName: eventName,
        template: confirmTemplate
      });
    },


    /**
      *  Close a noty by id
      * @param id
      */
    close: function close(id) {
      $.noty.close(id);
    }
};
